module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE2876.497bfd47.jpg";